import {Platform} from 'react-native';
import {Block, TransactionReceipt, TransactionResponse} from 'ethers';
import * as ethers from 'ethers';
import {TransactionPayload} from '../types';
import {ERC20} from './typechain-types';
export const maticId = '0x89';

export const Prices = {
  Cloud: {1: 20, 12: 400},
  Kiosk: {1: 20, 12: 400},
  WalletProtection: {1: 10, 12: 400},
};

export async function switchNet(chainId = `${maticId}`) {
  await window.ethereum.request({
    method: 'wallet_switchEthereumChain',
    params: [
      {
        chainId,
      },
    ],
  });
}
export let provider: ethers.BrowserProvider = {
  getSigner: () => ({}),
} as ethers.BrowserProvider;
const tryweb3 = () => {
  try {
    provider = new ethers.BrowserProvider(window.ethereum);
  } catch (err) {
    console.error('web3 error');
  }
};
tryweb3();
// There is only ever up to one account in MetaMask exposed
export const signer = () => provider.getSigner();

export async function sendMatic(
  from: string,
  to: string,
  valueNum: number,
  payload: TransactionPayload = {},
): Promise<string> {
  if (Platform.OS === 'web') {
    await switchNet();
    const value = ethers.parseEther(valueNum.toString()).toString(16);
    const abiCoder = new ethers.AbiCoder();
    const data = abiCoder.encode(
      ['string'],
      [JSON.stringify(payload)],
    );
    // const decoded = coder.decode(["string"], data)
    const txParams = {
      // The user's active address.
      from,
      // Required except during contract publications.
      to,
      // Only required to send ether to the recipient from the initiating external account.
      value,
      // Transaction payload
      data,
      // Customizable by the user during MetaMask confirmation.
      gasLimit: '0x76c0',
      gasPrice: (await provider.getFeeData()).gasPrice?.toString(16),
      // Customizable by the user during MetaMask confirmation.
      // maxPriorityFeePerGas: '0x3b9aca00',
      // // Customizable by the user during MetaMask confirmation.
      // maxFeePerGas: '0x2540be400',
    };
    console.info('txparams', txParams);
    const txHash: string = await window.ethereum.request({
      method: 'eth_sendTransaction',
      params: [txParams],
    });
    console.info('new transaction', txHash);
    return txHash;
  }
  return '';
}
export const erc20abi = [
  // Read-Only Functions
  'function balanceOf(address owner) view returns (uint256)',
  'function decimals() view returns (uint8)',
  'function symbol() view returns (string)',

  // Authenticated Functions
  'function transfer(address to, uint amount) returns (bool)',

  // Events
  'event Transfer(address indexed from, address indexed to, uint amount)',
];

export async function sendCoin(
  coin: string,
  to: string,
  amount: number,
) {
  const erc20 = new ethers.Contract(
    coin,
    erc20abi,
    await provider.getSigner(),
  );

  console.info(amount);
  const tx = await (await erc20.transfer(to, amount)).wait(1);
  return tx.hash;
}

export async function requestAccounts(): Promise<string[]> {
  if (Platform.OS === 'web') {
    // await switchNet();
    const accounts: string[] = await window.ethereum.request({
      method: 'eth_requestAccounts',
    });
    return accounts;
  }
  return [];
}

export async function getTransactionById(trxId: string) {
  const trx:
    | (TransactionResponse & {
        block?: Block | null;
        receipt?: TransactionReceipt | null;
      })
    | null = await provider.getTransaction(trxId);
  if (trx) {
    trx.block = await trx.getBlock();
    trx.receipt = await provider.getTransactionReceipt(trxId);
  }
  return trx;
}
